import { Slide } from "@jelly/lesson";

import { task as task04 } from "../../../../../task/course-01/lesson-03/task-04";

const task: Slide = {
  titleHtml:
    "Two acoustic waves propagate at a speed of 1 m/s in opposite directions and interfere.<br>The 7 pictures below depict the pressure as a function of the distance<br>at 7 different times between t = 0 s and t = 9 s.",
  description: "Drag and drop the images into the correct temporal order.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task04.id,
        },
      },
    },
  },
};

export default task;
